
import { useSearchOperations as useSearchOps } from './search/useSearchOperations';

export const useSearchOperations = useSearchOps;
export default useSearchOperations;
